<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<unpay2List></unpay2List>
		</div>
		<div class="add" v-if="type==='add'">
			2小时未结算详情
		</div>
	</div>
</template>
<script>
	import unpay2List from "./comp/unpay2_list.vue"
	export default {
		components:{unpay2List},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.activity.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
